import { yup } from '@guiker/yup-util'

export const googleConfigSchema = yup
  .object({
    googleApiKey: yup.string().required(),
  })
  .required()
